import React, { Fragment } from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { SimpleNotification } from 'Components/frameworks/notification/SimpleNotification';
import { PaymentInfo } from 'Components/widgets/payment-info/PaymentInfo';
import { PaymentInfoProvider } from 'Components/widgets/payment-info/PaymentInfoContext';
import { renderInfoBanner } from 'Components/widgets/info-banner/infoBanner.utils';
import type { InfoBannerData } from 'Components/widgets/info-banner/infoBanner.query';
import 'Components/widgets/info-banner/infoBanner.query';
import { t } from 'Src/i18n';
import { asInfoBannerArgs, makeViewProps } from 'Src/types/view-helpers';
import { Reassurance } from './Reassurance';
import { FailedPaymentModal } from './FailedPaymentModal';
import { PaidBankingFormContent } from './PaidBankingFormContent';
import { useBankingView } from './useBankingView';
type Props = {
  i18n: I18N;
  resort: ProductWithAccommodations;
  selectedProposal: Proposal;
  infoBannerData: InfoBannerData;
  additionalProviders?: Array<PaymentProvider>;
  attendeesPaymentStatus: Array<AttendeePaymentStatus>;
};

const BankingView = ({
  i18n,
  selectedProposal,
  additionalProviders = [],
  resort,
  infoBannerData,
  attendeesPaymentStatus,
}: Props) => {
  const {
    openFailedPaymentModal,
    handleFailedPaymentModalClose,
    paymentInfoValue,
    hasBasePaymentData,
    hasPaid,
    paymentProvidersWithValidMethods,
    household,
    payingHousehold,
  } = useBankingView({
    selectedProposal,
    additionalProviders,
    resort,
    attendeesPaymentStatus,
  });
  return (
    <Fragment>
      {renderInfoBanner(
        asInfoBannerArgs({
          infoBannerData,
          departureDate: selectedProposal.departureDate,
          arrivalDate: selectedProposal.arrivalDate,
          currentStep: 'banking',
        }),
      )}
      <SimpleNotification
        id="BankingViewInformations"
        content={t('booking.banking.paymentEmergency')}
        iconName={ICONS.CLOCK_SPEED}
        className="mb-20"
      />
      {openFailedPaymentModal && <FailedPaymentModal onClose={handleFailedPaymentModalClose} />}
      <PaymentInfoProvider value={makeViewProps<any>(paymentInfoValue)}>
        {hasBasePaymentData ? (
          <div className="flex flex-wrap justify-between">
            <div className="xs:w-full px-5 md:w-full">
              {hasPaid ? (
                <PaidBankingFormContent />
              ) : (
                <PaymentInfo
                  i18n={i18n}
                  paymentProviders={paymentProvidersWithValidMethods}
                  paymentSchedule={household.paymentSchedule}
                  price={household.paymentSchedule.total}
                  payingHousehold={payingHousehold}
                />
              )}
            </div>
          </div>
        ) : null}
      </PaymentInfoProvider>
      <Reassurance className="mt-20" i18n={i18n} />
    </Fragment>
  );
};

export { BankingView };
